// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","wrapper":"wrapper-1U2lf","wrapper_pointer":"wrapper_pointer-2j3Kh","active":"active-3MRZ7","selected":"selected-3I5dm"};